export default __webpack_public_path__ + "static/media/field.e06ab2f8.jpg";